import { CsvImportFlow } from '@/components/training/CsvImportFlow'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import {
  useImportOrganization,
  useOrganizationMembers,
  usePreviewImport,
} from '@/hooks/use-organizations'

const previewColumns = [
  { key: 'employeeNumber' as const, label: '社員コード' },
  { key: 'employeeName' as const, label: '社員氏名' },
  { key: 'departmentName' as const, label: '組織名' },
  { key: 'email' as const, label: 'メールアドレス' },
  { key: 'supervisorEmployeeNumber' as const, label: '直属上司コード' },
]

export default function OrganizationImportPage() {
  const { data, isLoading } = useOrganizationMembers()
  const importOrg = useImportOrganization()
  const previewImport = usePreviewImport()

  const members = data ?? []
  const memberById = new Map(members.map((m) => [m.id, m]))

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">組織マスター</h1>

      <CsvImportFlow
        title="組織マスター CSVインポート"
        onPreview={(csv) => previewImport.mutateAsync(csv)}
        onImport={(csv) => importOrg.mutateAsync(csv)}
        previewColumns={previewColumns}
      />

      <Card>
        <CardHeader>
          <CardTitle className="text-base">現在の組織メンバー ({members.length}件)</CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <Skeleton className="h-48" />
          ) : members.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-8">
              組織メンバーが登録されていません
            </p>
          ) : (
            <div className="max-h-96 overflow-auto">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>社員コード</TableHead>
                    <TableHead>氏名</TableHead>
                    <TableHead>組織名</TableHead>
                    <TableHead>メールアドレス</TableHead>
                    <TableHead>直属上司</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {members.map((m) => {
                    const supervisor = m.parentId ? memberById.get(m.parentId) : undefined
                    return (
                      <TableRow key={m.id}>
                        <TableCell>{m.employeeNumber ?? '-'}</TableCell>
                        <TableCell>{m.name}</TableCell>
                        <TableCell>{m.departmentName ?? '-'}</TableCell>
                        <TableCell className="text-xs text-muted-foreground">{m.email}</TableCell>
                        <TableCell>
                          {supervisor
                            ? `${supervisor.name}${supervisor.employeeNumber ? `（${supervisor.employeeNumber}）` : ''}`
                            : '-'}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
